import { combineReducers } from 'redux';
import { StateType } from 'typesafe-actions';
import accountsReducer from './accounts/reducers';
import authReducer from './auth/reducers';
import notesReducer from './notes/reducers';
import systemReducer from './system/reducers';
import transactionsReducer from './transactions/reducers';

/**
 * Create root Redux reducer by combining all application reducers into one
 */
export const createRootReducer = () =>
  combineReducers({
    accounts: accountsReducer,
    auth: authReducer,
    notes: notesReducer,
    system: systemReducer,
    transactions: transactionsReducer,
  });

export type State = StateType<ReturnType<typeof createRootReducer>>;
